import { Box, Typography } from '@mui/material';

export const Screen3GetStarted = () => {
  return (
    <div className="text-center p-6">
      <Box>
        <Typography variant="h2" my={4}>
          Let's get started!
        </Typography>

        <Typography fontSize={28}>Answer the following questions to retrieve your personalized executive pitch.</Typography>
      </Box>
      <Typography fontSize={24} mt={20} textAlign="center">
        Click arrow to begin.
      </Typography>
    </div>
  );
};
